import {
  getLinkEndNodeId,
  getLinkStartNodeId,
  pointInViewportBounds,
} from "../../../../helpers/modelBuilder/mbChatPureUtils";
import { sampleRows } from "./sampleRows";

export const MAX_RENDERED_NODES = 1200;
export const MIN_DETAIL_RENDER_ZOOM = 14;

export function linkEndpointIds(links) {
  const ids = new Set();
  (Array.isArray(links) ? links : []).forEach((link) => {
    const startId = getLinkStartNodeId(link);
    const endId = getLinkEndNodeId(link);
    if (startId) ids.add(startId);
    if (endId) ids.add(endId);
  });
  return ids;
}

export function selectNodesForRender({
  nodes,
  activeLayer,
  viewportBounds,
  selectedNodeIds,
  analysisColorFor,
  analysisOverlayActive,
  canRenderDetailLayer,
  nodeLinkAssociation,
  allEndpointIds,
  visibleEndpointIds,
  maxRenderedNodes,
}) {
  if (!viewportBounds) return [];
  if (activeLayer !== "nodes") return nodes.filter((node) => {
    const id = String(node?.node_id ?? node?.id ?? "");
    return (canRenderDetailLayer || selectedNodeIds?.has?.(id) || !!analysisColorFor(id))
      && pointInViewportBounds(node, viewportBounds);
  });

  const selected = [];
  const analysis = [];
  const connected = [];
  const unattached = [];
  nodes.forEach((node) => {
    const id = String(node?.node_id ?? node?.id ?? "");
    if (selectedNodeIds?.has?.(id)) { selected.push(node); return; }
    if (!pointInViewportBounds(node, viewportBounds)) return;
    const inAnalysis = !!analysisColorFor(id);
    // A result shows only its reported nodes, regardless of road context.
    if (analysisOverlayActive) {
      if (inAnalysis) analysis.push(node);
      return;
    }
    if (nodeLinkAssociation && visibleEndpointIds.has(id)) connected.push(node);
    else if (canRenderDetailLayer && (!nodeLinkAssociation || !allEndpointIds.has(id))) unattached.push(node);
  });
  const remainingAfterPriority = Math.max(0, maxRenderedNodes - selected.length - analysis.length);
  const sampledConnected = sampleRows(connected, remainingAfterPriority);
  const sampledUnattached = sampleRows(unattached, Math.max(0, remainingAfterPriority - sampledConnected.length));
  return [...selected, ...analysis, ...sampledConnected, ...sampledUnattached];
}

export function selectResultNodesForRender({ nodes, viewportBounds, selectedNodeIds, showNodes, zoom }) {
  const ordinaryNodes = nodes.filter((node) => !node.isDestination);
  if (!viewportBounds) return ordinaryNodes.filter((node) => selectedNodeIds.has(node.id));
  return selectNodesForRender({
    nodes: ordinaryNodes,
    activeLayer: "nodes",
    viewportBounds,
    selectedNodeIds,
    analysisColorFor: () => null,
    analysisOverlayActive: false,
    canRenderDetailLayer: showNodes && (!Number.isFinite(zoom) || zoom >= MIN_DETAIL_RENDER_ZOOM),
    nodeLinkAssociation: false,
    maxRenderedNodes: MAX_RENDERED_NODES,
  });
}
